module.exports = __webpack_public_path__ + "img/03.eab19b84.svg";